export const categories = {
  get_all: "products/category/",
  create: "products/category/",
  get_by_id: (id: number) => `products/category/get-by/?id=${id}`,
  delete: (id: number) => `products/category/?id=${id}`,
  edit: (id: number) => `products/category/?id=${id}`,
  get_by_atribute: (id: number) => `products/category/attribute/?id=${id}`,
};
